import type { AuthStrategy } from './types';

export { default as AuthProvider } from './AuthProvider.vue';
export { SKIP_AUTH_ROUTES } from './shared/SkipAuthRoutes';

async function getAuthStrategy(): Promise<AuthStrategy> {
  switch (import.meta.env.VITE_CLIENT) {
    case 'Premialab': {
      const { coreAuth } = await import('./core');

      return coreAuth();
    }
    case 'HSBC': {
      const { hsbcAuth } = await import('./hsbc');

      return hsbcAuth();
    }
    case 'Barclays': {
      const { barclaysAuth } = await import('./barclays');

      return barclaysAuth();
    }
    case 'BofA': {
      const { bofaAuth } = await import('./bofa');

      return bofaAuth();
    }
    case 'RBC': {
      const { rbcAuth } = await import('./rbc');

      return rbcAuth();
    }
    case 'SocGen': {
      const { socgenAuth } = await import('./socgen');

      return socgenAuth();
    }
    default: {
      throw new Error(`Unknown VITE_CLIENT value ${import.meta.env.VITE_CLIENT}`);
    }
  }
}

/**
 * Current active authentication strategy.
 *
 * The actual implementation of the strategy depends on the platform's
 * requirement.
 */
export const authStrategy = await getAuthStrategy();
